<template>
  <b-modal id="modal-localizacao"
    size="md"
    @show="showModalCredenciado"
    @hidden="resetModalCredenciado"
    hide-footer>
    <template v-slot:modal-title>
      Detalhes do {{ credenciado.tipo }}
    </template>
    <div class="row">
      <div class="col-12">
        <h6>{{ credenciado.nome }}</h6>
        <p class="mb-1">
          <small>
            <b-icon icon="telephone-fill" /> <a :href="`tel:${onlyNumber(credenciado.telefone)}`">{{ credenciado.telefone }}</a>
          </small>
        </p>
        <p class="mb-1">
          <small>
            <b-icon icon="cursor-fill" /> {{ credenciado.endereco }}
          </small>
        </p>
        <p class="mb-1">
          <small>
            <b-icon icon="house-door-fill" /> <a :href="`${credenciado.site}`" target="_blank">{{ credenciado.site }}</a>
          </small>
        </p>
      </div>
      <div class="col-12 map" :inner-html.prop="onlyHttps(credenciado.maps)">
      </div>
    </div>
  </b-modal>
</template>

<script>
import lodash from "lodash";

export default {
  props: ['credenciadoSelecionado'],
  data() {
    return {
      credenciado: {
        tipo: '',
        nome: '',
        email: '',
        site: '',
        enderecos: [],
        telefones: []
      },
    }
  },
  methods: {
    resetModalCredenciado() {
    },
    showModalCredenciado() {
      this.credenciado = this.credenciadoSelecionado
    },
    onlyNumber: string => {
      return string ? string.replace(/\D/ig, '') : ''
    },
    onlyHttps: string => {
      return string ? _.unescape(string.replace(/(http:\/\/)/, 'https:\/\/')) : ''
    },
  }
}
</script>

<style>

</style>
